import React from 'react';
import logo from '../../assets/logo-a.png';

/**
 * LogoMark — Bernardo Assad's "A" monogram (yellow line-art mark on a
 * transparent background, cropped from the brand artwork). Scales to any
 * size; used in the nav and mirrored as the favicon (public/logo.png).
 */
export function LogoMark({ size = 38, glow = true, style = {} }) {
  return (
    <img
      src={logo}
      alt="Bernardo Assad"
      width={size}
      height={size}
      style={{
        display: 'block',
        width: size,
        height: size,
        objectFit: 'contain',
        filter: glow ? 'drop-shadow(0 0 10px var(--yellow-a32))' : 'none',
        ...style,
      }}
    />
  );
}

export default LogoMark;
